import type { IapPack, Transaction } from '@/models'

import { PLAYERS } from './players'

export const PACKS: IapPack[] = [
  { id: 'p1', name: 'Starter Bundle', price: '$4.99', units: 18_402, revenue: 91_825, share: 27 },
  { id: 'p2', name: 'Season Pass', price: '$9.99', units: 12_940, revenue: 129_281, share: 38 },
  { id: 'p3', name: 'Gem Pile', price: '$1.99', units: 24_115, revenue: 47_989, share: 14 },
  { id: 'p4', name: 'Gem Chest', price: '$19.99', units: 3_204, revenue: 64_048, share: 19 },
  { id: 'p5', name: 'Legendary Crate', price: '$49.99', units: 812, revenue: 40_592, share: 12 },
  { id: 'p6', name: 'Emote Pack 9', price: '$2.99', units: 6_730, revenue: 20_122, share: 6 },
  { id: 'p7', name: 'Clan Boost', price: '$7.99', units: 2_180, revenue: 17_418, share: 5 },
  { id: 'p8', name: 'Arena Skin', price: '$14.99', units: 940, revenue: 14_091, share: 4 },
]

export const TRANSACTIONS: Transaction[] = Array.from({ length: 24 }, (_, i) => {
  const pack = PACKS[i % PACKS.length]
  return {
    id: 'txn_' + (91_200 + i * 53).toString(16),
    player: PLAYERS[(i * 7) % PLAYERS.length].username,
    pack: pack.name,
    amount: pack.price,
    channel: i % 2 === 0 ? ('App Store' as const) : ('Google Play' as const),
    ago: `${1 + ((i * 11) % 71)}h ago`,
    refundable: i % 5 !== 0,
  }
})

export const MONTHS = ['August 2026', 'July 2026', 'June 2026', 'May 2026']
export const CHANNELS = ['All channels', 'App Store', 'Google Play']
